import { combineReducers, createStore, applyMiddleware } from 'redux'
import { skusReducer } from './skus/reducer'
import { bundlesReducer } from './bundles/reducer'
import { offersReducer } from './offers/reducer'
import thunk from 'redux-thunk'
import { legalReducer } from './legal/reducer'

const rootReducer = combineReducers({
  skus: skusReducer,
  bundles: bundlesReducer,
  offers: offersReducer,
  legal: legalReducer
})

const configureStore = () => {
  const thunkMiddleware = applyMiddleware(thunk)

  return createStore(rootReducer, thunkMiddleware)
}

export type RootState = ReturnType<typeof rootReducer>
export default configureStore
